import { Expose } from "class-transformer";

export class CreateOfferDto {
  @Expose()
  code: string;

  @Expose()
  url?: boolean;
}
